/**
 * @fileoverview POST handler for the "/internal_user_groups/internal_user_group_upsert" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appSettingsInternalUserGroupsInternalUserGroupUpsertCacheKeys } from "./constants";
import type {
  AppSettingsInternalUserGroupsInternalUserGroupUpsertOptions,
  AppSettingsInternalUserGroupsInternalUserGroupUpsertResult,
} from "./types";

const nestedPropertyData = (
  propertyData: string,
  isEnabled: boolean,
  isDefault?: boolean
): Record<string, { is_enabled: boolean; is_default?: boolean }> => {
  if (isDefault === undefined) {
    return { [propertyData]: { is_enabled: !!isEnabled } };
  }

  return { [propertyData]: { is_enabled: !!isEnabled, is_default: !!isDefault } };
};

export const postAppSettingsInternalUserGroupsInternalUserGroupUpsert = reactQueryMutationAdapter(
  appSettingsInternalUserGroupsInternalUserGroupUpsertCacheKeys,
  ({
    appGroupId,
    internalUserGroupId,
    name,
    isEnabledUserEventLog,
    isEnabledContentTest,
    isDefaultContentTest,
    isEnabledSeedGroup,
    isDefaultSeedGroup,
    territoryId,
  }: AppSettingsInternalUserGroupsInternalUserGroupUpsertOptions): Promise<AppSettingsInternalUserGroupsInternalUserGroupUpsertResult> => {
    const body = {
      name,
      ...(territoryId ? { territory_ids: [territoryId] } : {}),
      ...(internalUserGroupId ? { internal_user_group_id: internalUserGroupId } : {}),
      ...nestedPropertyData("user_event_log", isEnabledUserEventLog),
      ...nestedPropertyData("content_test", isEnabledContentTest, isDefaultContentTest),
      ...nestedPropertyData("seed_group", isEnabledSeedGroup, isDefaultSeedGroup),
    };

    return fetch(`/internal_user_groups/internal_user_group_upsert?app_group_id=${appGroupId}`, "POST", body);
  }
);
